import { useState } from "react";
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";

function AdminLayout({ children }) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  return (
    <div
      className={[
        "admin-shell",
        isSidebarCollapsed ? "admin-shell--sidebar-collapsed" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <AdminSidebar
        activePath="/admin"
        isCollapsed={isSidebarCollapsed}
        isMobileOpen={isMobileSidebarOpen}
        onCloseMobile={() => setIsMobileSidebarOpen(false)}
        onToggleCollapsed={() =>
          setIsSidebarCollapsed((current) => !current)
        }
      />

      <div className="admin-shell__content">
        <AdminHeader
          onOpenSidebar={() => setIsMobileSidebarOpen(true)}
        />

        <main className="admin-main">{children}</main>
      </div>
    </div>
  );
}

export default AdminLayout;